module.exports = __webpack_public_path__ + "img/business-person.01257da0.png";